import { useIsInHomeEnabled } from "../lib/useIsInHomeEnabled";
import { InHomeHighlightedBookedVisitsList } from "./List";

export function InHomeHighlightedBookedVisitsContainer() {
  const isInHomeEnabled = useIsInHomeEnabled();
  if (!isInHomeEnabled) {
    return null;
  }

  return <InHomeHighlightedBookedVisitsList />;
}
